import { get } from '.';

export function GetVehicleInventories(options = {}) {
	return get<any>("/app/api/vehicle_inventories", options);
}
